import type { MouseEvent, ReactNode } from "react";
import { Link } from "../lib/router";

/**
 * Text you click: underlined, the colour of the sentence around it, darker on hover.
 * `to` goes to a page of the app, `href` opens a file or another site, `onClick` does something small.
 * `quiet` is a name that opens its thing (a meeting's title): underlined only on hover.
 */
export function TextLink({
  to,
  href,
  onClick,
  quiet = false,
  newTab,
  download,
  title,
  className = "",
  children,
}: {
  to?: string;
  href?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  quiet?: boolean;
  /** Opens `href` in a new tab; the default for a link to another site. */
  newTab?: boolean;
  download?: boolean | string;
  title?: string;
  className?: string;
  children: ReactNode;
}) {
  const cls = `${quiet ? "hover:underline" : "underline"} underline-offset-2 transition-colors hover:text-fg ${className}`;
  if (to) return <Link to={to} onClick={onClick} title={title} className={cls}>{children}</Link>;
  if (href) {
    const external = newTab ?? /^https?:\/\//.test(href);
    return (
      <a href={href} onClick={onClick} title={title} download={download} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined} className={cls}>
        {children}
      </a>
    );
  }
  return <button type="button" onClick={onClick} title={title} className={cls}>{children}</button>;
}
